import Beaker from "./containers/Beaker";
export default Beaker;